// form compress
export const interval =
'Change the value of "interval". Default value: 20 mm (recommended value: 20 mm ±3) \n \
Determine the value of Interval so that the blue line (circle line) comes to the position of the marking (horizontal line) in the SC section. \n \
Adjust the interval that cuts the stump in part. When the interval is narrow, it becomes close to the original shape, and conversely when it is wide it becomes a dull shape.'
export const compression =
'Input / change the value of “Compression” as following with below value. \n \
For PRO \n \
- Scan with PRO liner : 99% \n \
- *If scan with thin liner : 102% (for urgent alternative) \n \
\n \
For Lite (scan with thin liner) \n \
- Test fitting with just thick stump sock : 102% \n \
- Test fitting with thin liner : 102% \n \
- Test fitting with soft insert : 104% \n \
\n \
For Exo \n \
Set value for liner made in China \n \
- Scan without liner : 104-5% \n \
- Scan with thin liner : 102％ \n \
\n \
Reference \n \
- Thick liner　4-5% \n \
- Thin liner　2-3％ \n \
- Thin stump sock　1％ \n \
- Thick stump sock　2-3％ \n \
- ex: liner + thick stump sock　4-6%'
export const bottomExtension =
'Basically, 15mm. People with few soft tissue and long stick out terminals should be set longer. \n \
20 mm when the tibial end is obvious (less soft tissue distal to the stump).'
export const compressionIndividual =
'In order to narrow down the SC, squeeze it more than the Whole in the previous section. Determine the value for this. \n \
Set a partial pressure better than Whole in this item. \n \
If the SC section is narrow to begin with, it may be larger. \n \
If the middle section is too narrow, it may be widened. \n \
【Whole SC area】(Ref to figure) \n \
All areas from the above patella are decreased compression by 1.5% \n \
【Deeper SC area】(Ref to table) \n \
If the width of the SC portion is wider than the femoral condyle, it should be about additional 2-4% smaller than the whole. (Table) \n \
If the stump end is too large, it will not be inserted because it will be caught in the SC part of the socket, so do not make it too narrow. \n \
If the SC section is narrow to the original, there is no need to make it narrower. \n \
If the ML diameter and stump end of the femoral condyle is wider than the SC, it may be widened. \n \
Some people have SC sections so narrow or wide that they do not match the table. In that case, consult a Japanese PO. \n \
'